import type { ReactNode } from 'react'
import type {
  UseTwilioChatOptions,
  UseTwilioChatReturn,
} from '../types/chat.types'
import { useTwilioChat } from '../hooks/useTwilioChatTwilioFirst'
import { ChatContext } from './chatContext'

export interface ChatProviderProps {
  children: ReactNode
  config?: UseTwilioChatOptions
}

export const ChatProvider = ({ children, config }: ChatProviderProps) => {
  try {
    const chat = useTwilioChat(config)
    return <ChatContext.Provider value={chat}>{children}</ChatContext.Provider>
  } catch (error) {
    // If hook throws during initialization, provide a minimal context
    console.error('ChatProvider initialization error:', error)
    const errorContext: UseTwilioChatReturn = {
      client: null,
      conversation: null,
      messages: [],
      loading: false,
      error:
        error instanceof Error ? error.message : 'Failed to initialize chat',
      connectionState: 'disconnected',
      participantPresence: 'offline',
      sendMessage: async () => {
        throw new Error('Chat not initialized')
      },
      retryConnection: () => {},
      beginTyping: () => {},
      endTyping: () => {},
      typingParticipant: null,
      participantDisplayName: null,
      participantAvatarUrl: null,
      currentUserDisplayName: null,
    }
    return (
      <ChatContext.Provider value={errorContext}>
        {children}
      </ChatContext.Provider>
    )
  }
}
